class CollectionProductSwiper extends HTMLElement {
    constructor() {
        super();
        this._swiperContainer = null;
        this._swiperInstance = null;
        this._resizeHandler = this._onResize.bind(this);
    }

    connectedCallback() {
        requestAnimationFrame(() => {
            this._swiperContainer = this.querySelector('.swiper');
            this.initializeSwiper();
            window.addEventListener('resize', this._resizeHandler);
        });
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this._resizeHandler);
    }

    _onResize() {
        if (window.innerWidth > 1440) {
            if (this._swiperInstance) {
                const newSlidesOffsetBefore = this._calculateSlidesOffsetBefore();
                this._swiperInstance.params.slidesOffsetBefore = newSlidesOffsetBefore;
                this._swiperInstance.update();
            }
        }
    }

    _calculateSlidesOffsetBefore() {
        // 获取页面中第一个匹配的 .page-width 元素
        const element = document.querySelector('.page-width');

        if (!element) {
            console.log('没有找到匹配的元素');
            return 0;
        }

        // 获取元素的计算样式
        const computedStyle = getComputedStyle(element);

        // 获取 --page-width 的值
        const pageWidth = computedStyle.getPropertyValue('--page-width').trim();
        const pageWidthValue = parseFloat(pageWidth);
        const pageWidthUnit = pageWidth.match(/[a-zA-Z]+/)[0];

        let pageWidthInPx;
        if (pageWidthUnit === 'rem') {
            const rootFontSize = 10; // 根字体大小，可能需要根据实际情况调整
            pageWidthInPx = pageWidthValue * rootFontSize;
        } else {
            pageWidthInPx = pageWidthValue;
        }

        // 获取 --page-padding 的值
        const pagePadding = computedStyle.getPropertyValue('--page-padding').trim();
        const pagePaddingValue = parseFloat(pagePadding);
        const pagePaddingUnit = pagePadding.match(/[a-zA-Z]+/)[0];

        let pagePaddingInPx;
        if (pagePaddingUnit === 'rem') {
            const rootFontSize = 10; // 根字体大小，可能需要根据实际情况调整
            pagePaddingInPx = pagePaddingValue * rootFontSize;
        } else {
            pagePaddingInPx = pagePaddingValue;
        }

        // 计算滑动前的偏移量
        const slidesOffsetBefore = (window.innerWidth - pageWidthInPx - pagePaddingInPx) / 2;

        return slidesOffsetBefore;
    }

    initializeSwiper() {
        if (!this._swiperContainer) {
            console.error('Swiper container not found');
            return;
        }

        const nextButton = this._swiperContainer.querySelector('.swiper-button-next');
        const prevButton = this._swiperContainer.querySelector('.swiper-button-prev');
        const slidesOffsetBefore = this._calculateSlidesOffsetBefore();
        this._swiperInstance = new Swiper(this._swiperContainer, {
            slidesPerGroup: 1,
            slidesPerView: 5,
            spaceBetween: 26,
            loop: false,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            breakpoints: {
                // 
                // 
                // 820: {
                //     slidesPerView: 3,
                //     enabled: true,
                // },
                // 1180: {
                //     enabled: false,
                //     slidesPerView: this._blockCount,
                // },
                320: {
                    slidesPerView: 1.4,
                    spaceBetween: 15,
                    slidesOffsetBefore: 22,
                    slidesOffsetAfter: 22,
                },
                768: {
                    slidesPerView: 2.5,
                    slidesOffsetBefore: 22,
                    slidesOffsetAfter: 22,
                },
                1024: {
                    slidesOffsetBefore: 22,
                    slidesOffsetAfter: 22,
                    slidesPerView: 3,
                },
                1401: {
                    slidesOffsetBefore: slidesOffsetBefore,
                    slidesOffsetAfter: slidesOffsetBefore,
                    slidesPerView: 4,
                },
                1700: {
                    slidesOffsetBefore: slidesOffsetBefore,
                    slidesOffsetAfter: slidesOffsetBefore,
                    slidesPerView: 5,
                },
            },
        });
    }
}

customElements.define('collection-product-swiper', CollectionProductSwiper);